import { FinancialInfoStep } from "@/components/form-steps/InfoFinancieraStep";
import { registerStep } from "./stepsRegistry";
import type { StepDefinition } from "./types";
import { FinancialInfoSchema } from "@/schemas/multistep/financial-info.schema";

const definition: StepDefinition = {
  id: "informacionFinanciera",
  title: "Información financiera",
  schema: FinancialInfoSchema,
  Component: FinancialInfoStep,
  isApplicable: () => true,
};

registerStep(definition);
